import { TeamAccessType, TeamRole } from '@showbie-socrative/socrative-utils';

import axios from '../localAxios';
import { changeAccessLevelURL } from './urls';

interface ChangeAccessLevelParams {
  teamId: string;
  memberPublicId: string;
  newAccessType: TeamAccessType;
}

interface ChangeAccessLevelResponse {
  publicId: string;
  name: string;
  role: TeamRole;
  accessLevel: TeamAccessType;
  createdDate: string;
}
export async function changeAccessLevel({
  newAccessType,
  memberPublicId,
  teamId,
}: ChangeAccessLevelParams) {
  const url = changeAccessLevelURL({ teamId, publicId: memberPublicId });
  const response = await axios.post<ChangeAccessLevelResponse>(url.href, {
    accessType: newAccessType,
  });

  return response.data;
}
